import { useState } from "react";
import { apiRequest } from "../../network/apiClient";
import { jwtDecode } from "jwt-decode";
import { API_ENDPOINTS } from "../../api/apiEndpoints";
import { toast } from "react-toastify";

const AddContacts = ({ showModal, setShowModal, leadID, onContactAdded }) => {
    const [showLanguageDropdown, setShowLanguageDropdown] = useState(false);
    const [newContact, setNewContact] = useState({
        salutation: "MR.",
        name: "",
        designation: "",
        email: "",
        mobile_no: "",
        office_no: "",
        reporting_to: "No One",
        race_of_pic:"Malay",
        race_of_pic_others: "",
        language: ["English"],
        
    });

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        if (name === "language") {
            // handle multiple select for language
            const selectedOptions = Array.from(e.target.selectedOptions, option => option.value);
            setNewContact(prevState => ({
                ...prevState,
                [name]: selectedOptions
            }));
        }else {
            setNewContact( prevState =>({
                ...prevState,
                [name]: value
            }));
        }
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        // Call API to save the new contact
        try{
            newContact.lead_id = leadID;

            const result = await apiRequest(API_ENDPOINTS.UPDATE_ACCOUNTS.ADD_CONTACTS, "POST", newContact)

            if (result) {
                onContactAdded() // Call the callback to refresh the contact list
            } else {
                console.error("Error adding contact:", result.message);
            };
            
            toast.success('Contact successfully added')
        }catch(error){
            toast.error('Unable to save contact')
        }finally{
            setNewContact({
                salutation: "MR.",
                name: "",
                designation: "",
                email: "",
                mobile_no: "",
                office_no: "",
                reporting_to: "No One",
                race_of_pic:"Malay",
                race_of_pic_others: "",
                language: ["English"]
            });
            setShowModal(false);
            setShowLanguageDropdown(false);
        }
    };
    
    if(!showModal) return null;
    return(
        <div className="fixed inset-0 flex items-center justify-center z-50">
            <div
            className="fixed inset-0 bg-black opacity-50"
            onClick={() => setShowModal(false)}></div>
            <div className="w-[65%] bg-white rounded-lg shadow-lg p-6 z-10">
                <div className="w-full flex justify-center items-center mb-4 border-b">
                    <h2 className="text-xl font-bold mb-4">New Contact</h2>
                </div>
                <div className="grid grid-cols-2 gap-x-5 ml-3 text-[#475569]">
                    <div className ="flex items-start mt-5">
                        <p className="border-b border-gray-200 pb-2 w-full flex">
                            <span className="w-1/2">Salutation</span>
                            <select 
                                className="w-full bg-transparent focus:outline-none" 
                                defaultValue="MR."
                                id = "salutation"
                                name="salutation"
                                value={newContact.salutation}
                                onChange={handleInputChange}
                                required
                                >
                                    <option value="MR.">MR.</option>
                                    <option value="MS.">MS.</option>
                                    <option value="MRS.">MRS.</option>
                            </select>
                        </p>
                    </div>
                    <div className ="flex items-start mt-5">
                        <p className="border-b border-gray-200 pb-2 w-full flex">
                            <span className="w-1/2" >Name</span>
                            <input 
                                type="text" 
                                className="w-full"
                                id = "name"
                                name="name"
                                value={newContact.name}
                                onChange={handleInputChange}
                                required />
                        </p>
                    </div>
                    <div className ="flex items-start mt-5">
                        <p className="border-b border-gray-200 pb-2 w-full flex">
                            <span className="w-1/2">Designation</span>
                            <input 
                                type="text" 
                                className="w-full"
                                id = "designation"
                                name="designation"
                                value={newContact.designation}
                                onChange={handleInputChange}
                                required />
                        </p>
                    </div>
                    <div className ="flex items-start mt-5">
                        <p className="border-b border-gray-200 pb-2 w-full flex">
                            <span className="w-1/2">Email</span>
                            <input 
                                type="text" 
                                className="w-full"
                                id = "email"
                                name="email"
                                value={newContact.email}
                                onChange={handleInputChange}
                                required />
                        </p>
                    </div>
                    <div className ="flex items-start mt-5">
                        <p className="border-b border-gray-200 pb-2 w-full flex">
                            <span className="w-1/2 whitespace-nowrap" >Mobile Number</span>
                            <input 
                                type="text" 
                                className="w-full"
                                id = "mobile_no"
                                name="mobile_no"
                                value={newContact.mobile_no}
                                onChange={handleInputChange}
                                required />
                        </p>
                    </div>
                    <div className ="flex items-start mt-5">
                        <p className="border-b border-gray-200 pb-2 w-full flex">
                            <span className="w-1/2 whitespace-nowrap" >Office Number</span>
                            <input 
                                type="text" 
                                className="w-full"
                                id = "office_no"
                                name="office_no"
                                value={newContact.office_no}
                                onChange={handleInputChange}
                                required />
                        </p>
                    </div>
                    <div className ="flex items-start mt-5">
                        <p className="border-b border-gray-200 pb-2 w-full flex">
                            <span className="w-1/2" >Reporting to</span>
                            <select 
                                className="w-full" 
                                defaultValue="No One"
                                id = "reporting_to"
                                name="reporting_to"
                                value={newContact.reporting_to}
                                onChange={handleInputChange}
                                required
                                >
                                    <option value="No One">No One</option>
                                    <option value="Owner / CEO / Director">Owner / CEO / Director</option>
                                    <option value="CFO / Finance Director / Finance Manager">CFO / Finance Director / Finance Manager</option>
                                    <option value="Partner">Partner</option>
                            </select>
                        </p>
                    </div>
                    <div className ="flex items-start mt-5">
                        <div className="border-b border-gray-200 pb-2 w-full flex">
                            <span className="w-1/2" >Preferred Language</span>
                            <div className="w-full relative">
                                <div 
                                    className="w-full border border-gray-300 rounded px-2 py-1 cursor-pointer bg-white flex justify-between items-center"
                                    onClick={() => setShowLanguageDropdown(!showLanguageDropdown)}
                                    >
                                        <span>
                                            {newContact.language.length > 0
                                                ? newContact.language.join(", ")
                                                : "Select Language"}
                                        </span>
                                        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor" className="size-6">
                                            <path strokeLinecap="round" strokeLinejoin="round" d="m19.5 8.25-7.5 7.5-7.5-7.5" />
                                        </svg>
                                </div>
                                {showLanguageDropdown && (
                                    <div className="absolute top-full left-0 w-full bg-white border border-gray-399 rounded mt-1 z-10 shadow-lg">
                                        {['English', 'Bahasa Malaysia', 'Mandarin', 'Tamil', 'Hokkien', 'Cantonese'].map((lang) => (
                                            <label key={lang} className="flex items-center px-3 py-2 hover:bg-gray-100 cursor-pointer">
                                                <input
                                                    type="checkbox"
                                                    value={lang}
                                                    checked={newContact.language.includes(lang)}
                                                    onChange={(e) => {
                                                        const {value, checked} = e.target;
                                                        setNewContact(prevState => ({
                                                            ...prevState,
                                                            language: checked
                                                            ? [...prevState.language, value]
                                                            : prevState.language.filter(langItem => langItem !== value)
                                                        }));
                                                    }}
                                                    className="mr-2"
                                                />
                                                {lang}
                                            </label>
                                        ))}
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                    <div className ="flex items-start mt-5">
                        <p className="border-b border-gray-200 pb-2 w-full flex">
                            <span className="w-1/2" >Race</span>
                            <select 
                                className="w-full" 
                                id = "race_of_pic"
                                name="race_of_pic"
                                value={newContact.race_of_pic}
                                onChange={handleInputChange}
                                required
                                >
                                    <option value="Malay">Malay</option>
                                    <option value="Chinese">Chinese</option>
                                    <option value="Indian">Indian</option>
                                    <option value="Others">Others</option>
                            </select>
                        </p>
                    </div>
                    {newContact.race_of_pic ==='Others' && (
                        <div className ="flex items-start mt-5">
                            <p className="border-b border-gray-200 pb-2 w-full flex">
                                <span className="w-1/2 whitespace-nowrap" >If Others, Specify</span>
                                <input 
                                    type="text" 
                                    className="w-full"
                                    id = "race_of_pic_others"
                                    name="race_of_pic_others"
                                    value={newContact.race_of_pic_others}
                                    placeholder="Please specify"
                                    onChange={handleInputChange}
                                    required />
                            </p>
                        </div>
                    )}
                </div>
                <div className="flex justify-end mt-6 gap-4">
                    <button 
                        onClick={handleSubmit}
                        className="mt-4 bg-blue-500 text-white px-4 py-2 rounded"
                        >
                            Save
                    </button>
                    <button
                        onClick={() => setShowModal(false)}
                        type="button"
                        style={{ backgroundColor: "#F9FAFB" }}
                        className="mt-4 border bg-white text-[#475569] px-4 py-2 rounded"
                    >
                        Dismiss
                    </button>
                </div>
            </div>
        </div>
    );
};

export default AddContacts;